import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import {CityProps} from '../types';
import citiesKeys from '../util/cities-keys';

export interface EditCityProps extends Omit<CityProps, 'id'> {}

const useEditCity = (id: string) => {
  const {update} = useInfiniteQueryHelpers();
  const {setData} = useQueryHelpers();

  const onSuccess = (data: CityProps) => {
    update(citiesKeys.list(), data);
    setData(citiesKeys.details(id), data);
  };

  return useApiMutation<EditCityProps>({
    url: `/cities/${id}`,
    method: 'PATCH',
    errorTitle: 'Erro ao editar cidade',
    successTitle: 'Editar cidade',
    successMessage: 'Cidade atualizada com sucesso',
    onSuccess,
  });
};

export default useEditCity;
